import React, { useEffect, useState } from "react";
import { Icon, Message } from "semantic-ui-react";
import agent from "../../../api/agent";
import { NavLink } from "react-router-dom";

interface Props {
  schoolCode: string;
}

export default function MissingInvitationsWarning({ schoolCode }: Props) {
  const [invitationCount, setInvitationCount] = useState<number>(0);

  useEffect(() => {
    agent.Schools.missingInvitationsCount(schoolCode)
      .then((result) => setInvitationCount(result))
      .catch(() => {});
  }, [schoolCode]);

  const content = (
    <>
      <div id="divValidationMessages">
        <Message icon negative className="t4-error-msg">
          <Icon name="user" className="t4-custom-icn" />
          <Message.Content>
            <p>
            New staff: {invitationCount} member(s) of staff have not yet been sent an invitation(s).
              <NavLink to={`/dashboard/noinvitationmembers/${schoolCode}`}>{" View details"}</NavLink>
            </p>
          </Message.Content>
        </Message>
      </div>
    </>
  );

  return <>{invitationCount > 0 && content}</>;
}
